export function isIOSDevice() {
  if (typeof window === "undefined") return false;

  const platform = navigator.platform || "";
  const userAgent = navigator.userAgent || "";

  // Check for iOS devices
  const isIOS =
    /iPad|iPhone|iPod/.test(platform) ||
    (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream);

  // Check for iOS 13+ (iPad on Mac)
  const isMac = /Mac/.test(platform);
  const hasTouch = "ontouchend" in document;

  // For newer iPads running as desktop
  const isNewIPad = isMac && hasTouch && navigator.maxTouchPoints > 1;

  // Also check for iOS in user agent
  const isIOSUserAgent = /iPad|iPhone|iPod|Android/.test(userAgent);
  const isAndroidUserAgent = /Android/.test(userAgent);

  return isIOS || isIOSUserAgent || isNewIPad || isAndroidUserAgent;
}